
export const createPdfTablePageBreakRepair = () => {
  let repairs = [];
  let contentWidth = 0;

  const onclone = (clonedDocument) => {
    repairs = [];
    const container = clonedDocument.querySelector(".html2pdf__container");
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    contentWidth = containerRect.width;
    const view = clonedDocument.defaultView;

    container.querySelectorAll("table").forEach((table) => {
      const tableRect = table.getBoundingClientRect();
      const rows = Array.from(table.rows);

      rows.forEach((row, index) => {
        if (index === 0) return;
        const previousRow = rows[index - 1];
        const previousRect = previousRow.getBoundingClientRect();
        const rowRect = row.getBoundingClientRect();
        const gap = rowRect.top - previousRect.bottom;
        if (gap <= 2) return;

        const hasPageSpacer = Array.from(row.parentElement.children).some(
          (element) => {
            if (element.tagName !== "DIV" || element.children.length > 0) {
              return false;
            }
            const rect = element.getBoundingClientRect();
            return (
              rect.height > 0 &&
              rect.top >= previousRect.bottom - 1 &&
              rect.bottom <= rowRect.top + 1
            );
          },
        );
        if (!hasPageSpacer) return;

        const cell = row.cells[0];
        if (!cell) return;
        const style = view.getComputedStyle(cell);
        const borderSide = ["Top", "Bottom", "Left", "Right"].find(
          (side) =>
            parseFloat(style[`border${side}Width`]) > 0 &&
            !["none", "hidden"].includes(style[`border${side}Style`]),
        );
        if (!borderSide) return;

        const borderWidth = parseFloat(style[`border${borderSide}Width`]);
        const borderColor = style[`border${borderSide}Color`];
        repairs.push({
          left: tableRect.left - containerRect.left,
          width: tableRect.width,
          bottom: previousRect.bottom - containerRect.top,
          top: rowRect.top - containerRect.top,
          borderWidth,
          borderColor,
        });
      });
    });
  };

  const onrendered = (canvas) => {
    if (!contentWidth || repairs.length === 0) return;
    const context = canvas.getContext("2d");
    const scale = canvas.width / contentWidth;
    context.save();
    context.setTransform(1, 0, 0, 1, 0, 0);
    repairs.forEach((repair) => {
      const left = Math.floor(repair.left * scale);
      const right = Math.ceil((repair.left + repair.width) * scale);
      const bottom = Math.floor(repair.bottom * scale);
      const top = Math.ceil(repair.top * scale);
      const thickness = Math.max(1, Math.ceil(repair.borderWidth * scale));
      context.fillStyle = "white";
      context.fillRect(
        left - thickness,
        bottom,
        right - left + thickness * 2,
        top - bottom,
      );
      context.fillStyle = repair.borderColor;
      context.fillRect(left, bottom - thickness, right - left, thickness);
      context.fillRect(left, top, right - left, thickness);
    });
    context.restore();
  };

  return { onclone, onrendered };
};